import { Controller } from "@hotwired/stimulus"
import { followFrameRedirect, handleFrameNetworkError } from "../helpers/turbo_frame_error"

// Drives the "Zulagen neu berechnen" dialog: opening the native <dialog> (and loading its
// employee list), searching/toggling the employee checkboxes, and disabling submit while running.
export default class extends Controller {
  static targets = ["employeeItem", "checkbox", "submit", "search"]
  // Set by a deep link from an allowance card ("Zulagen neu berechnen"), which lands here
  // with the dialog's template and start date preset.
  static values = { open: Boolean }

  connect() {
    if (this.openValue) this.openDialog()
  }

  openDialog() {
    const dialog = document.getElementById("allowance-recalculate-dialog")
    if (dialog) {
      dialog.showModal()
      document.body.style.overflow = "hidden"
      this.loadEmployees(dialog)
    }
  }

  // The employee list is a lazy Turbo frame. Lazy frames load through an IntersectionObserver,
  // which a dialog opened during page load (the deep link) or a background tab does not
  // reliably trigger — switching the frame to eager makes Turbo fetch it right away.
  loadEmployees(dialog) {
    dialog.querySelectorAll('turbo-frame[loading="lazy"]').forEach((frame) => {
      frame.setAttribute("loading", "eager")
    })
  }

  close() {
    const dialog = document.getElementById("allowance-recalculate-dialog")
    if (dialog) {
      dialog.close()
      document.body.style.overflow = ""
    }
  }

  // The employee list loads after the dialog opens, so the search field and "Alle (ab)wählen"
  // may already have been used: each arriving row takes on that state.
  employeeItemTargetConnected(item) {
    this.filterItem(item)
  }

  checkboxTargetConnected(checkbox) {
    if (this.selection !== undefined) checkbox.checked = this.selection
  }

  // A list that never loads would leave the placeholder up for good — say so instead.
  employeesMissing(event) {
    followFrameRedirect(event)
  }

  employeesFailed(event) {
    handleFrameNetworkError(event)
  }

  searchEmployees() {
    this.employeeItemTargets.forEach((item) => this.filterItem(item))
  }

  filterItem(item) {
    const query = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ""
    const name = item.dataset.name.toLowerCase()
    item.classList.toggle("hidden", Boolean(query) && !name.includes(query))
  }

  selectAll(event) {
    event.preventDefault()
    this.setSelection(true)
  }

  deselectAll(event) {
    event.preventDefault()
    this.setSelection(false)
  }

  setSelection(checked) {
    this.selection = checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  submitStart() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
    }
  }
}
